(function () {
  function getMainProductSectionId() {
    var wrapper = document.querySelector('[data-product-free-shipping]');
    if (!wrapper) return null;
    var sectionEl = wrapper.closest('[data-section]');
    if (!sectionEl) return null;
    return sectionEl.dataset.section || null;
  }

  function toKey(section) {
    if (!section) return null;
    if (typeof section === 'string') return section;
    return section.section || section.id || null;
  }

  window.getCartFreeShippingSectionKeys = function (sections) {
    var keys = [];
    if (Array.isArray(sections)) {
      sections.forEach(function (s) {
        var key = toKey(s);
        if (key && keys.indexOf(key) === -1) keys.push(key);
      });
    }

    if (keys.indexOf('cart-free-shipping-progress') === -1) {
      keys.push('cart-free-shipping-progress');
    }

    var mainProductId = getMainProductSectionId();
    if (mainProductId && keys.indexOf(mainProductId) === -1) {
      keys.push(mainProductId);
    }

    return keys.join(',');
  };

  function replaceInner(targetEl, html, selector) {
    if (!targetEl || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var sourceEl = selector ? doc.querySelector(selector) : doc.body.firstElementChild;
    if (!sourceEl) return;
    targetEl.innerHTML = sourceEl.innerHTML;
  }

  window.updateCartFreeShippingSections = function (parsedState) {
    if (!parsedState || !parsedState.sections) return;

    var standaloneHtml = parsedState.sections['cart-free-shipping-progress'];
    if (standaloneHtml) {
      document.querySelectorAll('[data-cart-free-shipping-update]').forEach(function (bar) {
        if (bar.closest('[data-product-free-shipping]')) return;
        var doc = new DOMParser().parseFromString(standaloneHtml, 'text/html');
        var fresh = doc.querySelector('[data-cart-free-shipping-update]');
        if (fresh) bar.outerHTML = fresh.outerHTML;
      });
    }

    var mainProductId = getMainProductSectionId();
    if (mainProductId) {
      var productHtml = parsedState.sections[mainProductId];
      if (productHtml) {
        var pdpWrapper = document.querySelector('[data-product-free-shipping]');
        if (pdpWrapper) {
          var doc = new DOMParser().parseFromString(productHtml, 'text/html');
          var fresh = doc.querySelector('[data-product-free-shipping]');
          if (fresh) pdpWrapper.innerHTML = fresh.innerHTML;
        }
      }
    }
  };
})();
